export type ImportMode = 'validate' | 'execute';
export type ImportRowStatus = 'validated' | 'imported' | 'rejected';
export type ImportSheetName =
  | 'proyectos'
  | 'subproyectos'
  | 'proveedores'
  | 'items_catalogo'
  | 'items_subproyecto';

export interface ImportRowResult {
  row_number: number;
  status: ImportRowStatus;
  identifier: string | null;
  reason: string | null;
}

export interface ImportSheetResult {
  sheet_name: ImportSheetName;
  present: boolean;
  total_rows: number;
  valid_rows: number;
  imported_rows: number;
  rejected_rows: number;
  messages: string[];
  rows: ImportRowResult[];
}

export interface ImportWorkbookSummary {
  total_rows: number;
  valid_rows: number;
  imported_rows: number;
  rejected_rows: number;
}

export interface ImportWorkbookResult {
  mode: ImportMode;
  summary: ImportWorkbookSummary;
  sheets: ImportSheetResult[];
}

export const IMPORT_SHEET_LABELS: Record<ImportSheetName, string> = {
  proyectos: 'Proyectos',
  subproyectos: 'Subproyectos',
  proveedores: 'Proveedores',
  items_catalogo: 'Items catálogo',
  items_subproyecto: 'Items subproyecto',
};
